import React from 'react';
import { useSelector } from 'react-redux';
import { ANNUAL_RETURN_FORM, CHARITABLE_NOTIFICATION_OF_CHANGE_FORM, NEW_APPLICATION_FORM } from '../constants';

const organisationNavigation = [
  {
    label: <span>Preliminary questions</span>,
    url: '/organisation/preliminary-questions',
    default: true,
    step: 1
  },
  {
    label: <span>Organisation Conveyancer Licence</span>,
    url: '/organisation/dashboard',
    step: 2
  },
  {
    label: <span>Organisation</span>,
    url: '/organisation/registration',
    step: 3
  },
  {
    label: <span>Places of business</span>,
    url: '/organisation/places-of-business',
    step: 4
  },
  {
    label: <span>Add place of business</span>,
    url: '/organisation/add-business-place/:id?',
    step: 5
  }
];

const sampleItems = [
  {
    label: <span>Preliminary questions</span>,
    url: '/individual/preliminary-questions',
    default: true,
    step: 1
  },
  {
    label: <span>Individual Conveyancer Licence</span>,
    url: '/individual/dashboard',
    step: 2
  },
  {
    label: <span>Applicant Details</span>,
    url: '/individual/applicant-details',
    step: 3
  },
  {
    label: <span>Qualifications</span>,
    url: '/individual/qualifications',
    step: 4
  },
  {
    label: <span>Add a qualification</span>,
    url: '/individual/add-qualification/:id',
    step: 5
  },
  {
    label: <span>Employment details</span>,
    url: '/individual/employment-details',
    step: 6
  },
  {
    label: <span>Disclosures</span>,
    url: '/individual/disclosures',
    step: 6
  },
  // {
  //   label: <span>Work experience</span>,
  //   url: '/individual/work-experience',
  //   step: 6
  // },
  // {
  //   label: <span>Add work experience</span>,
  //   url: '/individual/add-work-experience/:id',
  //   step: 7
  // },
  {
    label: <span>Declaration</span>,
    url: '/{{form}}/declaration',
    step: 8
  },
  {
    label: <span>Payment</span>,
    url: '/{{form}}/fee-breakdown',
    step: 9
  }
];

const applicantDetailsItems = [
  {
    label: <span>Applicant Details</span>,
    url: '/{{form}}/applicant-details',
    default: true,
    step: 1
  }
];

const ownershipDetailsItems = [
  {
    label: <span>Ownership Details</span>,
    url: '/{{form}}/ownership-details',
    default: true,
    step: 1
  },
  {
    label: <span></span>,
    url: '/{{form}}/ownership-details/:ownershiptype',
    step: 2
  }
];

const closeAssociatesItems = [
  {
    label: <span>Close Associates and Employees</span>,
    url: '/{{form}}/close-associates/declaration',
    default: true,
    step: 1
  },
  {
    label: <span></span>,
    url: '/{{form}}/close-associates/corporations-detail',
    step: 2
  },
  {
    label: <span></span>,
    url: '/{{form}}/close-associates/employees-detail',
    step: 3
  },
  {
    label: <span></span>,
    url: '/{{form}}/close-associates/individuals-detail',
    step: 4
  }
];

const premisesItems = [
  {
    label: <span>Proposed Business Premises</span>,
    url: '/{{form}}/premises-details',
    default: true,
    step: 1
  }
];

const identityItems = [
  {
    label: <span>Proof of Identity</span>,
    url: '/{{form}}/proof-of-identity',
    default: true,
    step: 1
  },
  {
    label: <span>Qualification or Trade Reference Attachments</span>,
    url: '/{{form}}/identiy-attachments',
    default: true,
    step: 2
  }
];

const disclosureItems = [
  {
    label: <span>Disclosures</span>,
    url: '/{{form}}/disclosure',
    default: true,
    step: 1
  }
];

const collectionOfLicenceItems = [
  {
    label: <span>Collection of Licence</span>,
    url: '/{{form}}/collection-of-licence',
    default: true,
    step: 1
  }
];

const contactItems = [
  {
    label: <span>Review your application</span>,
    url: '/{{form}}/summary',
    step: 1
  },
  {
    label: <span>Declaration</span>,
    url: '/{{form}}/declaration',
    step: 2
  },
  {
    label: <span>Fee breakdown</span>,
    url: '/{{form}}/fee-breakdown',
    step: 3
  }
];

const getUrlWithStepNumber = (stepNumber) => {
  let url = '/';

  switch (stepNumber) {
    case 'step1': {
      url = '/tattooist-form/applicant-details';
      break;
    }
    case 'step2': {
      url = '/tattooist-form/employment';
      break;
    }
    case 'step3': {
      url = '/tattooist-form/disclosures';
      break;
    }
    case 'step4': {
      url = '/tattooist-form/collection-of-licence';
      break;
    }
    case 'step5': {
      url = '/tattooist-form/proof-of-identity';
      break;
    }
    case 'step6': {
      url = '/tattooist-form/upload-documents';
      break;
    }
    case 'step7': {
      url = '/tattooist-form/review-application';
      break;
    }
    case 'step8': {
      url = '/tattooist-form/declaration';
      break;
    }
    case 'step9': {
      url = '/tattooist-form/fee-breakdown';
      break;
    }
  }

  return url;
};

const annualReturnAuthorityItems = [
  {
    label: <span>Retrieve details</span>,
    url: '/annual-return/authority-information',
    default: true,
    step: 1
  }
];

const annualReturnDashboardItems = [
  {
    label: <span>Charitable Fundraising - Annual Return</span>,
    url: '/annual-return/dashboard',
    default: true,
    step: 1
  }
];

const annualReturnIndividualItems = [
  {
    label: <span>Applicant details</span>,
    url: '/annual-return/applicant-details',
    default: true,
    step: 1
  }
];

const annualReturnInformationItems = [
  {
    label: <span>Annual Return information</span>,
    url: '/annual-return/annual-return-information',
    default: true,
    step: 1
  }
];

const annualReturnTradersItems = [
  {
    label: <span>Traders</span>,
    url: '/annual-return/traders',
    default: true,
    step: 1
  }
];

const annualReturnBeneficiaryItems = [
  {
    label: <span>Beneficiaries</span>,
    url: '/annual-return/beneficiaries',
    default: true,
    step: 1
  },
  {
    label: <span>Add beneficiary</span>,
    url: '/annual-return/add-beneficiary',
    default: true,
    step: 1
  }
];

const annualReturnOrganisationItems = [
  {
    label: <span>Organisation details</span>,
    url: '/annual-return/organisation-details',
    default: true,
    step: 1
  }
];

const annualReturnItems = [
  {
    label: <span>Retrieve details</span>,
    url: '/annual-return/authority-information',
    default: true,
    step: 1
  },
  {
    label: <span>Review</span>,
    url: '/annual-return/review',
    step: 2
  },
  {
    label: <span>Annual Return information</span>,
    url: '/annual-return/annual-return-information',
    step: 3
  },
  {
    label: <span>Traders</span>,
    url: '/annual-return/traders',
    step: 4
  },
  {
    label: <span>Beneficiaries</span>,
    url: '/annual-return/beneficiaries',
    step: 5
  },
  {
    label: <span>Review</span>,
    url: '/annual-return/confirmation',
    step: 6
  },
  {
    label: <span>Declaration</span>,
    url: '/annual-return/confirmation',
    step: 7
  },
  {
    label: <span>Declaration</span>,
    url: '/annual-return/declaration',
    step: 8
  },
  {
    label: 'Confirmation', // Application submitted
    url: '/annual-return/success',
    step: 9
  }
];

function useIsRenewal() {
  const authorityInformation = useSelector((state) => state.authorityInformation);
  const licenceFullDetail = useSelector((state) => state.licenceFullDetail);
  const renewalDetail = useSelector((state) => state.renewalDetail);
  const isRenewalSuccessPage =
    sessionStorage['notification_applicationNo'] && !!!sessionStorage['notification_applicationNo'].startsWith('APP');
  //return licenceFullDetail?.licenceInfo?.status === 'Expired' || !!renewalDetail?.renewalNumber;
  //return !!renewalDetail?.renewalNumber && authorityInformation?.licenceInfo?.isRenewal;
  return !!renewalDetail?.renewalNumber || !!isRenewalSuccessPage;
}

function useIsRenewalAsk() {
  const authorityInformation = useSelector((state) => state.authorityInformation);
  const licenceFullDetail = useSelector((state) => state.licenceFullDetail);
  const renewalDetail = useSelector((state) => state.renewalDetail);
  //return licenceFullDetail?.licenceInfo?.status === 'Expired' || !!renewalDetail?.renewalNumber;
  if (authorityInformation?.licenceInfo?.isRenewal || authorityInformation?.licenceInfo?.isRestoration) {
    return true;
  }
}

const getAnnualReturnUrlWithStepNumber = (stepNumber) => {
  let url = '/';

  if (!!!stepNumber) {
    url = '/annual-return/dashboard';
    return url;
  }

  switch (stepNumber) {
    case 'step1': {
      url = '/annual-return/annual-return-information';
      break;
    }
    case 'step2': {
      url = '/annual-return/traders';
      break;
    }
    case 'step2.1': {
      url = '/annual-return/add-trader';
      break;
    }
    case 'step3': {
      url = '/annual-return/beneficiaries';
      break;
    }
    case 'step4': {
      url = '/annual-return/confirmation';
      break;
    }
    case 'step5': {
      url = '/annual-return/dashboard';
      break;
    }
  }

  return url;
};

const getRedirectUrlPost2fa = (form, ext) => {
  let url = '/';

  if (!form) {
    return url;
  }

  switch (form) {
    case ANNUAL_RETURN_FORM: {
      url = '/annual-return/dashboard';
      break;
    }
    case NEW_APPLICATION_FORM: {
      if (ext === 'individual') {
        url = '/new-application/individual/duration';
        break;
      }

      if (ext === 'organisation') {
        url = '/new-application/organisation/duration';
        break;
      }
    }
    case CHARITABLE_NOTIFICATION_OF_CHANGE_FORM: {
      url = '/notification-change/dashboard';
      break;
    }
  }

  return url;
};

export {
  sampleItems,
  organisationNavigation,
  applicantDetailsItems,
  ownershipDetailsItems,
  closeAssociatesItems,
  premisesItems,
  identityItems,
  disclosureItems,
  collectionOfLicenceItems,
  contactItems,
  getUrlWithStepNumber,
  annualReturnAuthorityItems,
  annualReturnDashboardItems,
  annualReturnIndividualItems,
  annualReturnInformationItems,
  annualReturnTradersItems,
  annualReturnBeneficiaryItems,
  annualReturnOrganisationItems,
  annualReturnItems,
  useIsRenewal,
  useIsRenewalAsk,
  getAnnualReturnUrlWithStepNumber,
  getRedirectUrlPost2fa
};
